<template>
    <div>
        <button class="button is-info is-outlined" @click="zoomIn">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15 9H9V15H7V9H1V7H7V1H9V7H15V9Z" fill="#0B9096"/>
            </svg>
        </button>
        <button class="button is-info is-outlined" @click="zoomOut">
            <svg width="16" height="16" viewBox="0 -8 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14 2H8H6H0V0H6H8H14V2Z" fill="#0B9096"/>
            </svg>
        </button>
    </div>   
</template>
<script>
	export default {
		props: {
			map: {
				type: Object,
				required: true
			}
		},
		methods: {
			zoomIn(){
				this.map.zoomIn();
            },
			zoomOut(){
				this.map.zoomOut();
			}
		}
	};
</script>
<style scoped lang="scss">
</style>
